import { STATE_NAME } from '../constants';
import * as reducerSelectors from '../reducer';

export default function getCountryCode(state) {
  return reducerSelectors.getCountryCode(state[STATE_NAME]);
}
